import React from 'react';

import './HomePage.css';
import HomeContent from './HomeContent';

const HomePage = () => {
  return (
    <div className="home-page">
      <div className="home-page-elements">
        <HomeContent />
      </div>
    </div>
  );
};

export default HomePage;
